import { css } from '@/styled-system/css';

export const moduleContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
  width: '100%',
});

export const mapSection = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
});

export const mapContainer = css({
  width: '100%',
  height: '200px',
  borderRadius: '8px',
  overflow: 'hidden',
  bg: 'hpxGrey100',
  position: 'relative',
  md: {
    height: '240px',
  },
});

export const fallbackContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  bg: 'hpxGrey100',
  color: 'hpxGrey600',
  padding: '2x',
  textAlign: 'center',
});

export const fallbackIcon = css({
  fontSize: '2xl',
  marginBottom: '1x',
  opacity: 0.6,
});

export const fallbackText = css({
  fontSize: 'sm',
  fontWeight: '500',
  marginBottom: 'xs',
});

export const fallbackSubtext = css({
  fontSize: 'tiny',
  color: 'hpxGrey500',
});

export const neighborhoodInfo = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'xs',
  paddingTop: '1x',
  paddingBottom: '1x',
  paddingLeft: '0',
  paddingRight: '0',
});

export const neighborhoodStats = css({
  display: 'flex',
  gap: '2x',
  flexWrap: 'wrap',
  fontSize: 'sm',
  color: 'hpxGrey600',
});

export const statItem = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  fontSize: 'tiny',
  color: 'hpxGrey500',
});

export const commuteSection = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
  marginTop: '2x',
});
